import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from 'src/app/ui/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { ISmartInboxState, ISmartInboxStateType } from '../../models/inbox.models';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inbox-error',
  standalone: true,
  imports: [ButtonComponent, TranslateModule, CommonModule],
  templateUrl: './inbox-error.component.html',
  styleUrls: ['./inbox-error.component.scss'],
})
export class InboxErrorComponent {
  readonly SMART_INBOX_STATE = ISmartInboxState;

  @Input() errorType: ISmartInboxStateType = ISmartInboxState.CONNECTION_ERROR;

  @Output() onAction = new EventEmitter<void>();

  constructor() {}

  ngOnDestroy(): void {
  }

  action(): void {
    this.onAction.emit();
  }

  refresh(): void {
    window.location.reload();
  }
}
